module.exports = "https://cdn.hellotech.com/client-assets/yelp-badge_4d4bdd45b11f70dbe5139a11207e996d.png";